module.exports = __webpack_public_path__ + "static/media/documentationIcon.eb5b9895.svg";